// extracted by mini-css-extract-plugin
module.exports = {"empty-asset":"empty-asset-3sUqC","emptyAsset":"empty-asset-3sUqC","icon":"icon-17nMB","message":"message-1B42E","action-edit":"action-edit-3Dyjx","actionEdit":"action-edit-3Dyjx"};